import AccessStatus from "./AccessStatus";

export const Banner = {
  AccessStatus,
};

export default Banner;
